import React from 'react';
import { Form, Input, Button, Select, Radio } from 'antd';

const { Option } = Select;

const RackRegistryForm = ({ onFinish, initialValues, loading }) => {
  const [form] = Form.useForm();

  return (
    <Form
      form={form}
      onFinish={onFinish}
      layout="vertical"
      initialValues={initialValues}
    >
      <Form.Item
        name="rack_name"
        label="Rack Name"
        rules={[{ required: true, message: 'Please input rack name!' }]}
      >
        <Input />
      </Form.Item>

      <Form.Item name="lock_code" label="Lock Code">
        <Input />
      </Form.Item>

      <Form.Item name="labeled_as" label="Labeled As">
        <Input />
      </Form.Item>

      <Form.Item
        name="numbering_direction"
        label="Direction of Numbering"
        rules={[
          { required: true, message: 'Please select numbering direction!' },
        ]}
        initialValue="high-to-low"
      >
        <Radio.Group>
          <Radio value="high-to-low">High to Low</Radio>
          <Radio value="low-to-high">Low to High</Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item
        name="total_u"
        label="Total U"
        rules={[{ required: true, message: 'Please select total U!' }]}
      >
        <Select>
          {[...Array(52)].map((_, index) => (
            <Option key={index + 1} value={index + 1}>
              {index + 1}U
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item name="notes" label="Notes">
        <Input.TextArea rows={4} />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          {initialValues ? 'Update' : 'Create'}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default RackRegistryForm;
